import { render, staticRenderFns } from "./AdjustCollectedMoneyDialog.vue?vue&type=template&id=fa95f410&scoped=true"
import script from "./AdjustCollectedMoneyDialog.vue?vue&type=script&lang=js"
export * from "./AdjustCollectedMoneyDialog.vue?vue&type=script&lang=js"
import style0 from "./AdjustCollectedMoneyDialog.vue?vue&type=style&index=0&id=fa95f410&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa95f410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa95f410')) {
      api.createRecord('fa95f410', component.options)
    } else {
      api.reload('fa95f410', component.options)
    }
    module.hot.accept("./AdjustCollectedMoneyDialog.vue?vue&type=template&id=fa95f410&scoped=true", function () {
      api.rerender('fa95f410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/AdjustCollectedMoneyDialog.vue"
export default component.exports